const Mutations = Object.freeze({
	SET_ALLPROJECTS: 'userProject/SET_ALLPROJECTS',
	SET_USERPROJECTS: 'userProject/SET_USERPROJECTS',
	SET_LOADING: 'userProject/SET_LOADING',
});
export const Actions = Object.freeze({
	LOAD_ALLPROJECTS: 'userProject/LOAD_ALLPROJECTS',
	LOAD_USERPROJECTS: 'userProject/LOAD_USERPROJECTS',
	LOAD: 'userProject/LOAD',
	INSERT_USERPROJECTS: 'userProject/INSERT_USERPROJECTS',
	DELETE_USERPROJECTS: 'userProject/DELETE_USERPROJECTS',
});
export const Getters = Object.freeze({
	USERPROJECTS: 'userProject/USERPROJECTS',
	ASSIGNEDPROJECTS: 'userProject/ASSIGNEDPROJECTS',
	UNASSIGNEDPROJECTS: 'userProject/UNASSIGNEDPROJECTS',
	PROJECTS: 'userProject/PROJECTS',
	IS_LOADING: 'userProject/IS_LOADING',
});
import dataService from '../../../../../services/data/clientUserManagementService';
import { GeneralActions } from '../../../../actions';
export default {
	state: {
		userProjects: [],
		projects: [],
		loading: false,
	},
	mutations: {
		[Mutations.SET_ALLPROJECTS](state, items) {
			state.projects = items;
		},
		[Mutations.SET_USERPROJECTS](state, items) {
			state.userProjects = items;
		},
		[Mutations.SET_LOADING](state, item) {
			state.loading = item;
		},
	},
	actions: {
		[Actions.LOAD_ALLPROJECTS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getAllProjects()
					.then((resp) => {
						commit(Mutations.SET_ALLPROJECTS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
					});
			});
		},
		[Actions.LOAD_USERPROJECTS]({ commit, dispatch }, userId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.getAllUserProjects(userId)
					.then((resp) => {
						commit(Mutations.SET_USERPROJECTS, resp.data);
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD]({ dispatch }, userId) {
			return Promise.all([
				dispatch(Actions.LOAD_ALLPROJECTS),
				dispatch(Actions.LOAD_USERPROJECTS, userId),
			]);
		},
		[Actions.INSERT_USERPROJECTS](
			{ commit, dispatch },
			{ userId, projects }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.postUserProject(userId, projects)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.DELETE_USERPROJECTS](
			{ commit, dispatch },
			{ userId, projects }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.deleteUserProject(userId, projects)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.IS_LOADING]: (state) => {
			return JSON.parse(JSON.stringify(state.loading));
		},
		[Getters.USERPROJECTS]: (state) => {
			return JSON.parse(JSON.stringify(state.userProjects));
		},
		[Getters.PROJECTS]: (state) => {
			return JSON.parse(JSON.stringify(state.projects));
		},
		[Getters.ASSIGNEDPROJECTS]: (state) => {
			let result = [];
			state.projects.forEach((p) => {
				let assigned = state.userProjects.find(
					(x) => x.ProjectId == p.Id
				);
				if (assigned) result.push(p);
			});
			return result;
		},
		[Getters.UNASSIGNEDPROJECTS]: (state) => {
			let result = [];
			state.projects.forEach((p) => {
				let assigned = state.userProjects.find(
					(x) => x.ProjectId == p.Id
				);
				if (!assigned) result.push(p);
			});
			return result;
		},
	},
};
